import { createElement } from 'react';
import { b as __rest, R as Icon$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var Icon = function Icon(_a) {
  var name = _a.name,
    props = __rest(_a, ["name"]);
  return /*#__PURE__*/createElement(Icon$1, __assign({
    name: "uq-ec-".concat(name)
  }, props));
};
Icon.displayName = 'Icon';

export { Icon };
